import Box from "@mui/material/Box";
import FolderOpenIcon from "@mui/icons-material/FolderOpen"; // MUI Folder Icon

const SubCategoryIcon = ({ color, variant }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: color,
        borderRadius: "8px",
        // padding: "8px",
        width: variant === "sm" ? "40px" : "60px",
        height: variant === "sm" ? "40px" : "60px",
      }}
    >
      <FolderOpenIcon
        sx={{
          fontSize: variant === "sm" ? 30 : 50, // Adjust size based on variant
          color: "#ffffff", // Ensures contrast against background
        }}
      />
    </Box>
  );
};

export default SubCategoryIcon;
